// src/native.js
// Whether the app runs inside the Android/iOS app (Capacitor) instead of a browser. There the app files come with the app,
// so the service worker is not used, and signing in with Google goes through the phone's own accounts.
import { Capacitor } from '@capacitor/core';

export const isNativeApp = () => {
    try {
        return Capacitor.isNativePlatform();
    } catch (error) {
        return false;
    }
};

export const isNativeIos = () => {
    try {
        return Capacitor.isNativePlatform() && Capacitor.getPlatform() === 'ios';
    } catch (error) {
        return false;
    }
};

// The address other people open: the website. Inside a phone app the page's own address (https://localhost or
// capacitor://localhost) means nothing to anybody else, so links made there (a share link, an invite) use the website's.
export const PUBLIC_ORIGIN = 'https://tournamental.app';
export const publicOrigin = () => (isNativeApp() ? PUBLIC_ORIGIN : window.location.origin);
